<template>
  <div class="address-wrapper">
    <p v-if="!isClicked" >
      {{row.tpr_address}}
    </p>
    <Input v-else v-model="row.tpr_address" @on-enter="edit"/>
    <div class="buttons-wrapper">
      <Icon
          :type="!isClicked ? 'md-create' : 'md-checkmark'"
          :size="!isClicked ? 16 : 22"
          :color="!isClicked ? '#555555' : '#35C030'"
          class="icon"
          @click="!isClicked ? clickToEdit() : edit()"
      />
      <Icon
          type="md-close"
          size="22"
          :color="'#F65858'"
          class="icon"
          v-if="isClicked"
          @click.prevent="close"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "EditWallet",
  props: {
    row: {
      type: Object,
    }
  },
  data() {
    return {
      isClicked: false,
      prevAddress: ""
    }
  },
  methods: {
    clickToEdit() {
      this.isClicked = true;
      this.prevAddress = this.row.tpr_address
    },
    close() {
       this.isClicked = false;
       this.row.tpr_address = this.prevAddress
    },
    edit() {
      if (this.row.tpr_address && this.row.tpr_address.trim() !== "") {
        this.$store.dispatch("editWallet", {
          id: this.row.id,
          address: this.row.tpr_address
        })
        .then(res => {
          this.$Message.success({
            content: res.data.status,
            duration: 5
          })
          this.isClicked = false;
          this.changesToParent(this.row)
        })
        .catch((err) => {
          this.$Message.error({
            content: err.response.data.error,
            duration: 5
          })
          this.row.tpr_address = "";
          this.isClicked = true;
        })
      } else {
        this.$Message.error({
          content: "TPR Wallet address can not be empty",
          duration: 5
        })
      }
    },
    changesToParent(data) {
      this.$emit('changeAddress', data)
    }
  },

}
</script>

<style lang="scss" scoped>
  .address-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      cursor: pointer;
    }

    .buttons-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>